import { Col, Row, message, Tabs, DatePicker, InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import { fetchAllSubcategory } from "redux/features/subcategory";
import { fetchAllWajib } from 'redux/features/wajib_pajak';
import { fetchAllTags } from "redux/features/tags";
import { getUserProfile } from "redux/features/auth";
import { kabupatens, masalah_kdkmp, categories, sdgs, status_kdkmp } from '../../../constants/DataConstant'
import { fetchAllUser, deleteUser } from 'redux/features/user';
import Map from "../../../components/EditableMap";
import {
  addProject,
  fetchOneProject,
  updateProject,
} from "redux/features/projects";
import { MyEditor } from "../../../components/Editor";
import moment from "moment";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "WAJIB DIISI!",
  },
];

export const DETAIL_PROJECT = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [perusahaan, setPerusahaan] = useState("");
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState("");
  const [pmo, setPMO] = useState([]);
  const [ba, setBA] = useState([]);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [potensi_penduduk, setPotensiPenduduk] = useState("");
  const [jumlah_anggota, setJumlahAnggota] = useState("");
  const [kebutuhan, setKebutuhan] = useState("");
  const [laporan, setLaporan] = useState("");
  const [bast, setBast] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [role, setRole] = useState('');

  const [kabupaten, setKabupaten] = useState("");
  const [opd, setOpd] = useState("");
  const [kategori, setKategori] = useState("");
  const [sdg, setSdg] = useState("");

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData({
        ...values,
        id: location.state.id,
      });
    } else {
      createData(values);
    }
  };

  const getProfile = async () => {
    try {
      const response = await dispatch(getUserProfile()).unwrap();
      setUsername(response.data.user.username);
      setRole(response.data.user.role_id)
      setPerusahaan(response.data.user.perusahaan)
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getDataBA = async (params) => {
    try {
      const profile = await dispatch(getUserProfile()).unwrap();
      const bas = await dispatch(fetchAllUser({
        ...params,
        limit:100,
        role_id: 3,
        kabupaten: profile.data.user.kabupaten,
      })).unwrap()
      const pmos = await dispatch(fetchAllUser({
        ...params,
        limit:100,
        role_id: 2,
        kabupaten: profile.data.user.kabupaten,
      })).unwrap()
      const transformedBA = bas.data.map(item => ({
        value: item.username,
        label: item.username
      }));
      const transformedPMO = pmos.data.map(item => ({
        value: item.username,
        label: item.username
      }));
      setBA(transformedBA)
      setPMO(transformedPMO)
    } catch (error) {
      message.error(error?.message || 'Failed to fetch data')
    }
  }

  const getAllCompanies = async () => {
    try {
      const { data } = await dispatch(fetchAllWajib({ limit: 1000 })).unwrap();
      const list_pt = data.data.map(item => ({
        value: item.perusahaan,
        label: item.perusahaan
      }));

      setCompanies(list_pt);
    } catch (err) {
      console.log(err)
    }
  }

  // latitude={-2.990934} longitude={104.756554}
  const [markerLocation, setMarkerLocation] = useState({
    latitude: -2.990934,
    longitude: 104.756554,
  });

  // Function to handle marker location change from MapboxMap
  const handleLocationChange = (latitude, longitude) => {
    setMarkerLocation({ latitude, longitude });
  };

  const createData = async (values) => {
    try {
      await dispatch(addProject({
        ...values,
        name: values.name.toUpperCase(),
        latitude: markerLocation.latitude ? markerLocation.latitude?.toString() : "-2.990934",
        longitude: markerLocation.longitude ? markerLocation.longitude?.toString() : "104.756554",
        opd: values.opd || "LAINNYA",
        ahu: values.ahu || "-",
        kecamatan: values.kecamatan ? values.kecamatan : "SUMATERA SELATAN",
        kelurahan: values.kelurahan ? values.kelurahan : "SUMATERA SELATAN",
        koordinat: values.koordinat ? values.koordinat : "SUMATERA SELATAN",
        kabupaten: values.kabupaten ? values.kabupaten : "SUMATERA SELATAN",
        endDate: values.deadline,
        masalah: values.masalah || "TIDAK BERMASALAH",
        kategori: values.kategori || "LAINNYA",
        pic_id: 1,
        vendor_id: 1,
        file: '-',
        owner: role === 1 ? values.perusahaan : perusahaan,
        status: values.status || "BELUM PENDAMPINGAN",
        verification: values.verification || "BELUM PENDAMPINGAN",
        id_pmo: values.id_pmo || "-",
        id_ba: values.id_ba || "-",
        desa: values.desa || "-",
        no_phone: values.no_phone || "-",
        diskon_pajak: values.diskon_pajak || 0,
        cost: parseInt(values.cost || 0),
        potensi_penduduk: parseInt(values.potensi_penduduk || 0),
        jumlah_anggota: parseInt(values.jumlah_anggota || 0),
        bast: bast,
        proposal: values.proposal || "-",
        owner: values.owner || "-",
        certificate: values.certificate ? values.certificate : "-",
        laporan: values.laporan || "-",
        description: values.description || "-",
        startDate: values.startDate || moment().format("YYYY-MM-DD"),
        endDate: values.endDate || moment().format("YYYY-MM-DD"),
        deadline: values.deadline || moment().format("YYYY-MM-DD"),
        pelaksana: values.pelaksana || "-",
        lokasi: values.lokasi || "-",
        bast: "-",
        nib: values.nib || "-",
        potensi_desa: values.potensi_desa || "-",
        ketua_koperasi: values.ketua_koperasi || "-",
        nilai_sroi: parseInt(values.nilai_sroi) || 0,
        simpanan_pokok: parseInt(values.simpanan_pokok) || 0,
        simpanan_wajib: parseInt(values.simpanan_wajib) || 0,
        anggaran_dasar: parseInt(values.anggaran_dasar) || 0,
        actual: parseInt(values.actual) || 0,
        kebutuhan: kebutuhan || "-",
        perusahaan: values.perusahaan || "-",
        sdg: "-",

        apotek: values.apotek ? values.apotek : "FALSE",
        klinik: values.klinik ? values.klinik : "FALSE",
        simpan_pinjam: values.simpan_pinjam ? values.simpan_pinjam : "FALSE",
        kantor: values.kantor ? values.kantor : "FALSE",
        logistik: values.logistik ? values.logistik : "FALSE",
        sembako: values.sembako ? values.sembako : "FALSE",
        cold_storage: values.cold_storage ? values.cold_storage : "FALSE",
      })).unwrap();
      if (role === 3) {
        history.push("/app/projects-opd");
      } else if (role === 1) {
        history.push("/app/projects");
      } else {
        history.push("/app/my-projects");

      }
    } catch (error) {
      message.error(error.message || "Ada yang salah dengan data anda! Pastikan semua nilai terisi, jika tidak ada isikan dengan nilai '-'");
    }
  };

  const getTags = async () => {
    try {
      const response = await dispatch(fetchAllTags()).unwrap();
      setTags(
        response.data.map((tag) => {
          return {
            value: tag.id,
            label: tag.name,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(updateProject({
        ...values,
        name: values.name.toUpperCase(),
        latitude: markerLocation.latitude ? markerLocation.latitude?.toString() : "-2.990934",
        longitude: markerLocation.longitude ? markerLocation.longitude?.toString() : "104.756554",
        status_kdkmp: values.status_kdkmp || "BELUM PENDAMPINGAN",
        opd: values.opd || "LAINNYA",
        ahu: values.ahu || "-",
        kecamatan: values.kecamatan ? values.kecamatan : "SUMATERA SELATAN",
        kelurahan: values.kelurahan ? values.kelurahan : "SUMATERA SELATAN",
        koordinat: values.koordinat ? values.koordinat : "SUMATERA SELATAN",
        kabupaten: values.kabupaten ? values.kabupaten : "SUMATERA SELATAN",
        endDate: values.deadline,
        sgd: values.sdg || "LAINNYA",
        bast:"-",
        kebutuhan: kebutuhan || "-",
        sdg: values.sdg || "LAINNYA",
        masalah: values.masalah || "TIDAK BERMASALAH",
        kategori: values.kategori || "LAINNYA",
        pic_id: 1,
        vendor_id: 1,
        file: '-',

        owner: role === 1 ? values.perusahaan : perusahaan,
        status: values.status || "BELUM PENDAMPINGAN",
        verification: values.verification || "BELUM PENDAMPINGAN",
        id_pmo: values.id_pmo || "-",
        id_ba: values.id_ba || "-",
        desa: values.desa || "-",
        no_phone: values.no_phone || "-",
        diskon_pajak: values.diskon_pajak || 0,
        cost: parseInt(values.cost || 0),
        potensi_penduduk: parseInt(values.potensi_penduduk || 0),
        jumlah_anggota: parseInt(values.jumlah_anggota || 0),
          bast:"-",
        kebutuhan:"-",
        proposal: values.proposal || "-",
        owner: values.owner || "-",
        certificate: values.certificate ? values.certificate : "-",
        laporan: values.laporan || "-",
        description: values.description || "-",
        startDate: values.startDate || moment().format("YYYY-MM-DD"),
        endDate: values.endDate || moment().format("YYYY-MM-DD"),
        deadline: values.deadline || moment().format("YYYY-MM-DD"),
        pelaksana: values.pelaksana || "-",
        lokasi: values.lokasi || "-",
        nib: values.nib || "-",
        potensi_desa: values.potensi_desa || "-",
        ketua_koperasi: values.ketua_koperasi || "-",
        nilai_sroi: parseInt(values.nilai_sroi) || 0,
        simpanan_pokok: parseInt(values.simpanan_pokok) || 0,
        simpanan_wajib: parseInt(values.simpanan_wajib) || 0,
        anggaran_dasar: parseInt(values.anggaran_dasar) || 0,
        actual: parseInt(values.actual) || 0,
        kebutuhan: "-",
        perusahaan: values.perusahaan || "-",
        sdg: "-",

        apotek: values.apotek ? values.apotek : "FALSE",
        klinik: values.klinik ? values.klinik : "FALSE",
        simpan_pinjam: values.simpan_pinjam ? values.simpan_pinjam : "FALSE",
        kantor: values.kantor ? values.kantor : "FALSE",
        logistik: values.logistik ? values.logistik : "FALSE",
        sembako: values.sembako ? values.sembako : "FALSE",
        cold_storage: values.cold_storage ? values.cold_storage : "FALSE",
      })).unwrap();
      if (role === 3) {
        history.push("/app/projects-opd");
      } else if (role === 1) {
        history.push("/app/projects");
      } else {
        history.push("/app/my-projects");

      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneProject(id)).unwrap();
      setMarkerLocation({
        latitude: parseFloat(data.data.latitude),
        longitude: parseFloat(data.data.longitude),
      })
      setKabupaten(data.data.kabupaten)
      setKategori(data.data.kategori)
      setSdg(data.data.sdg)
      setOpd(data.data.opd)
      setKebutuhan(data.data.kebutuhan)
      setLaporan(data.data.laporan)
      setBast(data.data.bast)
      setLatitude(data.data.latitude)
      setLongitude(data.data.longitude)
      setJumlahAnggota(data.data.jumlah_anggota)
      setPotensiPenduduk(data.data.potensi_penduduk)
      form.setFieldsValue({
        ...data.data,
        startDate: moment(data.data.startDate),
        deadline: moment(data.data.deadline),
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getSubcategories = async () => {
    try {
      const response = await dispatch(fetchAllSubcategory()).unwrap();
      setSubcategories(
        response.data.map((category) => {
          return {
            value: category.id,
            label: category.name,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    getProfile()
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
    getSubcategories()
    getTags()
    getAllCompanies()
    getDataBA()
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update KDKMP {kabupaten}</h2>
          <p>Tolong isi KDKMP di form ini sesuai dengan data</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Nama KDKMP"
                name="name"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="AHU"
                name="ahu"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="NIB"
                name="nib"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Apakah Bermasalah?"
                name="masalah"
              >
                <Select options={masalah_kdkmp}></Select>
              </Form.Item>


              <Form.Item
                label="Koordinat (Link Google Map)"
                name="koordinat"
              >
                <Input defaultValue={'-'} />
              </Form.Item>

              {(location?.state?.id) ? (
                <Card>
                  {(markerLocation.latitude && markerLocation.longitude) ?
                    <Map latitude={parseFloat(markerLocation.latitude)} longitude={parseFloat(markerLocation.longitude)} onMarkerChange={handleLocationChange}></Map>
                    : <Map latitude={-2.990934} longitude={104.756554} onMarkerChange={handleLocationChange}></Map>}
                </Card>
              ) : (
                <Card>
                  <Map latitude={-2.990934} longitude={104.756554} onMarkerChange={handleLocationChange}></Map>
                </Card>
              )}

              <Form.Item
                label="Alamat Lengkap"
                name="lokasi"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Desa (Contoh: SUKAMAJU)"
                name="desa"
              >
                <Input defaultValue={"LAINNYA"} />
              </Form.Item>

              <Form.Item
                label="Kelurahan (Contoh: SILABERANTI)"
                name="kelurahan"
              >
                <Input defaultValue={"LAINNYA"} />
              </Form.Item>

              <Form.Item
                label="Kecamatan (Contoh: SEBERANG ULU I)"
                name="kecamatan"
              >
                <Input defaultValue={"LAINNYA"} />
              </Form.Item>

              <Form.Item
                label="Kabupaten"
                name="kabupaten"
              >
                <Select defaultValue={kabupaten} options={kabupatens} />
              </Form.Item>

              <Form.Item
                label="PMO"
                name="id_pmo"
              >
                <Select options={pmo} />
              </Form.Item>

              <Form.Item
                label="BA"
                name="id_ba"
              >
                <Select options={ba} />
              </Form.Item>

              <Form.Item
                label="Jumlah Anggota KDKMP"
                name="jumlah_anggota"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Potensi Penduduk"
                name="potensi_penduduk"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Ketua Koperasi"
                name="ketua_koperasi"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Tanggal Didirikan (DD/MM/YYYY)"
                name="start_date"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Anggaran Dasar"
                name="anggaran_dasar"

              >
                <InputNumber style={{ width: "100%" }} defaultValue={0} />
              </Form.Item>

              <Form.Item
                label="Status KDKMP"
                name="status"
              >
                <Select
                  defaultValue={"BELUM PENDAMPINGAN"}
                  style={selectStyle}
                  options={status_kdkmp}
                />
              </Form.Item>

              {role === 1 && (
                <Form.Item
                  label="Verifikasi PMO"
                  name="verification"
                >
                  <Select
                    defaultValue={"BELUM PENDAMPINGAN"}
                    style={selectStyle}
                    options={status_kdkmp}
                  />
                </Form.Item>
              )}

              <Form.Item
                label="Kantor"
                name="kantor"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="Sembako"
                name="sembako"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="Simpan Pinjam"
                name="simpan_pinjam"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="Apotek"
                name="apotek"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="Klinik"
                name="klinik"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="Logistik"
                name="logistik"
              >
                <Select
                  defaultValue="Not Picked"
                  style={selectStyle}
                  options={[{
                    value: "TRUE",
                    label: "TRUE"
                  },
                  {
                    value: "FALSE",
                    label: "FALSE"
                  }]}
                />
              </Form.Item>

              <Form.Item
                label="No Phone"
                name="no_phone"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Deskripsi (Max 255 Characters)"
                name="description"
                defaultValue="-"
              >
                <Input />
              </Form.Item>

              <Tabs>
                <Tabs.TabPane tab="Biodata Koperasi" label="item-1">
                  <Form.Item>
                    <MyEditor
                      data={kebutuhan}
                      setState={setKebutuhan}
                      defaultValue="Konten"
                    />
                  </Form.Item>
                </Tabs.TabPane>

              </Tabs>

              <Tabs>
                <Tabs.TabPane tab="Laporan" label="item-1">
                  <Form.Item>
                    <MyEditor
                      data={bast}
                      setState={setBast}
                      defaultValue="Konten"
                    />
                  </Form.Item>
                </Tabs.TabPane>

              </Tabs>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  {location?.state?.id ? "Update KDKMP" : "Tambah KDKMP"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DETAIL_PROJECT;
